import { useEffect, useRef, useState } from "react";
import signature from "../../assets/images/signature.png"; // adjust path if needed

const DynamicTextArea = ({ value: initialValue, onChange, signatureEnabled = true, signatureUrl }) => {
  const [value, setValue] = useState(initialValue);
  const [fontSize, setFontSize] = useState(12.1);
  const ref = useRef();

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const { scrollHeight } = ref.current;
    if (scrollHeight > 209) {
      setFontSize(fontSize - 0.2);
    }
  }, [value, fontSize]);

  const handleChange = (e) => {
    setValue(e.target.value);
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <div style={{ flex: "1 1 0%", position: "relative" }}>
      <textarea
        name="findings"
        ref={ref}
        className="content"
        value={value}
        onChange={handleChange}
        style={{
          fontSize: `${fontSize}px`,
          overflow: "hidden",
          resize: "none",
          border: "none",
          outline: "none",
          width: "100%",
          boxSizing: "border-box",
          background: "transparent",
          padding: "8px",
          paddingBottom: "5%", 
          lineHeight: "1.4",
          height: "206px"
        }}
      />

      {/* Doctor Signature + Prepared By Section (shown only when enabled) */}
      {signatureEnabled && (
        <div
          style={{
            position: "absolute",
            bottom: "8px",
            left: "8px",
            right: "8px",
            fontSize: "8px",
            lineHeight: "1.2",
            userSelect: "none",
            color: "black",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            pointerEvents: "none",
            fontFamily: "inherit",
            whiteSpace: "nowrap",
            overflow: "hidden",
            marginLeft: "2%"
          }}
        >
          {/* Signature image (uploaded or default) */}
          <img
            src={
              signatureUrl
                ? typeof signatureUrl === "string"
                  ? signatureUrl
                  : URL.createObjectURL(signatureUrl)
                : signature
            }
            alt="Doctor Signature"
            style={{
              height: "22px",
              marginBottom: "2px",
              pointerEvents: "none",
              marginLeft: "10%",
            }}
          />

          <div style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-between" }}>
            <span style={{ whiteSpace: "nowrap", marginRight: "1px", flex: "0 0 auto" }}>Prepared By: Dr. Pramod Narkhede</span>
            <span style={{ whiteSpace: "nowrap", flex: "1 1 auto", overflow: "hidden", textOverflow: "ellipsis",marginLeft:"1px" }}>
              MBBS, DNB(Medicine), DNB (Cardiology) <span style={{ marginLeft: "1px" }}>Reg: 2004/09/3195</span>
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default DynamicTextArea;
